import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default abstract class BaseSelectController extends Controller {
    /**
     * Derived controllers must provide the URL to fetch data.
     */
    abstract get url(): string;

    /**
     * Optionally override this method to provide a custom templateResult
     * for formatting Select2 results.
     */
    templateResult?(state: any): any;

    /**
     * Determines if the select should allow multiple selections.
     * Override in the derived controller to enable multiselect.
     */
    get multiple(): boolean {
        return false;
    }

    connect(): void {
        const config: any = {
            language: 'ru',
            theme: "bootstrap-5",
            containerCssClass: "select2--small",
            selectionCssClass: "select2--small",
            dropdownCssClass: "select2--small",
            allowClear: true,
            width: '100%',
            ajax: {
                url: this.url,
                dataType: "json",
                delay: 250,
                data: (params: any) => {
                    return {
                        search: params.term,
                        page: params.page || 1,
                    };
                },
                processResults: (data: any, params: any) => {
                    params.page = params.page || 1;
                    return {
                        results: data.items,
                        pagination: {
                            more: (params.page * data.per_page) < data.total_count
                        }
                    };
                },
                cache: true,
            },
        };

        // Include the multiple option if required by the derived controller.
        if (this.multiple) {
            config.multiple = true;
        }

        // If the derived controller provides a templateResult function, merge it in.
        if (this.templateResult) {
            config.templateResult = this.templateResult;
        }

        $(this.element).select2(config);

        $(this.element).on("select2:select", (e) => {
            this.element.classList.remove("is-invalid");

            // Remove the error message, if found.
            // if (this.hasErrorMessageTarget) {
            //     this.errorMessageTarget.remove();
            // }
        });
    }

    disconnect(): void {
        $(this.element).select2("destroy");
    }
}
